import { Injectable } from "@angular/core";
import {
    ActivatedRouteSnapshot,
    CanActivate,
    CanActivateChild,
    Router,
    RouterStateSnapshot,
} from "@angular/router";
import { QualityAssuranceAdminService } from "../quality-assurance/admin-service";

@Injectable()
export class QualityAssuranceAuth implements CanActivate, CanActivateChild {
    private readonly router: Router;
    private readonly qualityAssuranceAdminService: QualityAssuranceAdminService;

    constructor(
        router: Router,
        qualityAssuranceAdminService: QualityAssuranceAdminService
    ) {
        this.router = router;
        this.qualityAssuranceAdminService = qualityAssuranceAdminService;
    }

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Promise<boolean> {
        return this.isAllowedAccess(route, state);
    }

    canActivateChild(
        childRoute: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Promise<boolean> {
        return this.isAllowedAccess(childRoute, state);
    }

    private async isAllowedAccess(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Promise<boolean> {
        let returnVal = false;
        let accessTypes = route.data.accessTypes;

        try {
            returnVal = await this.qualityAssuranceAdminService.canAccess(
                accessTypes
            );

            if (!returnVal) this.router.navigateByUrl("/unauthorized");
        } catch {
            this.router.navigateByUrl("/unauthorized");
        }

        return returnVal;
    }
}
